import { forwardRef, useCallback } from "react";
import PropTypes from "prop-types";
import is from "@sindresorhus/is";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useMediaQuery from "@mui/material/useMediaQuery";

import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";

import ChevronDown from "../../../icons/ChevronDown";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Popup = props => {
  const { children, onClose, open, sx, ...others } = props;
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down("md"));

  const onClose_ = useCallback(() => is.function(onClose) && onClose(), [onClose]);

  return (
    <Dialog
      fullScreen
      onClose={onClose_}
      open={open}
      PaperComponent={props => {
        const { children, sx, ...others } = props;

        return (
          <Paper elevation={0} square sx={{ ...sx, background: theme.palette.background.paper }} {...others}>
            <Container disableGutters maxWidth="lg">
              {children}
            </Container>
          </Paper>
        );
      }}
      TransitionComponent={Transition}
      sx={{ mt: 4, mx: compact ? 0 : 4, mb: 0 }}
      {...others}
    >
      <Box onClick={onClose} sx={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
        <ChevronDown
          sx={{
            px: 2,
            "&:hover": {
              cursor: "pointer",
              borderRadius: 1,
              background: "rgba(255,255,255,0.03)",
              transform: "scale(1.02)",
              transition: "transform 0.4s"
            }
          }}
        />
      </Box>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

Popup.defaultProps = {
  children: null,
  label: "Label",
  onClose: null,
  open: false,
  sx: null
};

Popup.propTypes = {
  children: PropTypes.any,
  label: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  sx: PropTypes.object
};

export default Popup;
